export function configuratorPricingLifeCycleEventBusTrigger(propProductData) {
  LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_pricing_event', propProductData);
}
